<template>
    <v-app id="form">
     <v-form ref="form">
        <v-layout row class="px-lg-5">

            <v-flex lg12 xs12> 

                    <v-row class="ml-lg-n4 ml-1 mt-lg-5 mt-2">

                            <v-col cols="2" lg="12" xs="12">

                                <v-row style="width:380px !important;">

                                    <div class="mt-lg-2"> <v-img src="@/assets/images/Monitoring/assignment.svg" /> </div> <div class="mt-2 ml-2"> {{tutorName}} </div>
                                   
                                </v-row>

                            </v-col>

                    </v-row>

                
                    <v-layout row class="mt-10 px-2">


                                            <v-flex lg3 xs12>
                                                        <v-row>

                                                            <div> <v-img src="@/assets/images/Monitoring/student.svg"  aspect-ratio='1' contain max-width="30"/> </div> 
                                                              <v-text-field :rules="inputRules" v-model="studName" label="STUDENT’S NAME"  v-bind="attrs" v-on="on" class="input-size mt-n4 ml-2 styled-input"></v-text-field>
                                                            

                                                        </v-row>
                                            </v-flex>

                                            <v-flex lg3 xs12 class="ml-lg-16 mt-lg-0 mt-10">
                                                        <v-row>

                                                            <div> <v-img src="@/assets/images/Monitoring/calendar.svg"  aspect-ratio='1' contain max-width="100"/> </div> 
                                                            <v-row>
                                                                <v-col cols="11" sm="6" md="4" lg="12">
                                                                <v-menu ref="menudate"  v-model="menudate" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition"
                                                                    offset-y min-width="auto">

                                                                    <template v-slot:activator="{ on, attrs }">
                                                                    <v-text-field :rules="inputRules" v-model="date" label="CLASS DATE" readonly v-bind="attrs" v-on="on" class="input-size mt-n4 ml-2"></v-text-field>
                                                                    </template>
                                                                    <v-date-picker v-model="date" no-title scrollable :min="rangeIsFrom" :max="rangeIsTo">
                                                                    <v-spacer></v-spacer>
                                                                    <v-btn text color="primary" @click="menudate = false">
                                                                        Cancel
                                                                    </v-btn>
                                                                    <v-btn text color="primary" @click="$refs.menudate.save(date)">
                                                                        OK
                                                                    </v-btn>
                                                                    </v-date-picker>
                                                                </v-menu>
                                                                </v-col>
                                                            </v-row>

                                                        </v-row>


                                        </v-flex>

                                                    
                                        <v-flex lg3 xs12 class="ml-lg-16 mt-lg-0 mt-10">
                                                        <v-row>

                                                            <div> <v-img src="@/assets/images/Monitoring/clock.svg"  aspect-ratio='1' contain max-width="20"/> </div>  
                                                            <v-row>
                                                                <v-col cols="11" sm="5" lg="12">
                                                                <v-menu ref="menu" v-model="menu2" :close-on-content-click="false" :nudge-right="40" :return-value.sync="time" transition="scale-transition"
                                                                    offset-y max-width="290px" min-width="290px"
                                                                >
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                    <v-text-field :rules="inputRules" v-model="time"  label="CLASS TIME" readonly  v-bind="attrs" v-on="on" class="input-size mt-n4 ml-2"></v-text-field>
                                                                    </template>
                                                                    <v-time-picker v-if="menu2" v-model="time"
                                                                    full-width
                                                                    format="24hr"
                                                                    @click:minute="$refs.menu.save(time)"
                                                                    ></v-time-picker>
                                                                </v-menu>
                                                                </v-col>
                                                        </v-row>

                                                        </v-row>
                                        </v-flex>
                            </v-layout>

   
                                            

                </v-flex>

                <v-flex lg12 class="mt-10 ml-n2">

                    
                        <div class="barcolor">

                           <div> <span class="ml-lg-5" > Type of Complaint* </span> </div>
                            <div> <span class="ml-lg-5 text-lg-caption" > Please check all that apply based on the student's feedback. </span> </div>

                        </div>
                        <div class="textareaBg mt-n1">

                            <v-layout row class="pb-5">

                                <v-flex lg12 class="ml-lg-6 mt-lg-5">

                                       <v-checkbox :rules="inputRules" value="1" v-model="chkData" label="1.  Lack of Skills: Knowledgeability: GRAMMAR"> </v-checkbox> 

                                        <v-checkbox :rules="inputRules" value="2" v-model="chkData" label="2.  Lack of Skills: Knowledgeability: PRONUNCIATION"> </v-checkbox> 

                                        <v-checkbox :rules="inputRules" value="3" v-model="chkData" label="3.  Lack of Skills: Knowledgeability: VOCABULARY"> </v-checkbox> 

                                        <v-checkbox :rules="inputRules" value="4" v-model="chkData" label="4.  Lack of Skills: Teaching: PREPAREDNESS"> </v-checkbox> 
                                        
                                        <v-checkbox :rules="inputRules" value="5" v-model="chkData" label="5.  Lack of Skills: Teaching: COMMUNICATION"> </v-checkbox> 

                                        <v-checkbox :rules="inputRules" value="6" v-model="chkData" label="6.  Lack of Skills: Teaching: SENSITIVITY TO STUDENT'S NEEDS"> </v-checkbox>

                                        <v-checkbox :rules="inputRules" value="7" v-model="chkData" label="7.  Punctuality: DID NOT START ON TIME"> </v-checkbox>

                                        <v-checkbox :rules="inputRules" value="8" v-model="chkData" label="8.  Punctuality: DID NOT START ON TIME"> </v-checkbox>

                                        <v-checkbox :rules="inputRules" value="9" v-model="chkData" label="9.  Technical: CALL QUALITY (noise, choppy line, call disconnection)"> </v-checkbox>

                                        <v-checkbox :rules="inputRules" value="10" v-model="chkData" label="10.  ATTITUDE"> </v-checkbox>

                                        <v-checkbox :rules="inputRules" value="11" v-model="chkData" label="11.  ATTENDANCE OF THE INSTRUCTOR"> </v-checkbox>
                                        

                                        <v-row class="ml-0"> 
                                        <v-checkbox :rules="inputRules" value="other" v-model="chkData" label="12. Other:" @change="OtherChange()"> </v-checkbox>

                                    
                                             <v-text-field :rules="chkData.includes('other') ? inputRules: ''" v-model="othersChk"  :readonly="chkData.includes('other') ? false : true" v-bind="attrs" v-on="on" class="input-size-other mt-n2 ml-2 styled-input"></v-text-field>
                                            </v-row>

                                           

                                </v-flex>

                            </v-layout>

                        </div>  

                </v-flex>

                <v-flex lg12 class=" ml-n2 mt-2">

                    
                        <div class="barcolor">

                           <div> <span class="ml-lg-5" > Details of the Complaint* </span> </div>
                        

                        </div>
                        <div class="textareaBg mt-n1">

                            <v-layout>
                                <v-flex lg12 class="ml-lg-10">

                                    <v-textarea
                                    placeholder="Please put as much detail as possible."
                                    class="textarea"
                                    auto-grow
                                    v-model="complaints"
                                    :rules="inputRules"
                                    ></v-textarea>

                                </v-flex>

                            </v-layout>

                        </div>  

                </v-flex> 

                <v-flex lg12 class=" ml-n2 mt-2">

                    
                        <div class="barcolor">

                           <div> <span class="ml-lg-5" > Action Taken by KR Admin * </span> </div>
                        

                        </div>
                        <div class="textareaBg mt-n1">

                            <v-layout row class="pb-5">

                                    <v-flex lg12>

                                         <v-radio-group v-model="actTaken" class="ml-6" :rules="inputRules" @change="OtherChange()">

                                             <v-radio value="1"></v-radio> <label class="ml-lg-2 chkboxLabel"> 
                                                <v-row class="mt-n7 ml-6"> <div> 1. Transfer to another instructor </div> 
                                                </v-row> </label>

                                             <v-radio  value="2"></v-radio> <label class="ml-lg-2 chkboxLabel"> 
                                                <v-row class="mt-n7 ml-6"> <div> 2. End contract </div> 
                                                </v-row> </label>

                                             <v-radio value="3"></v-radio> <label class="ml-lg-2 chkboxLabel"> 
                                                <v-row class="mt-n7 ml-6"> <div> 3. Refund </div> 
                                                </v-row> </label>

                                             <v-radio value="4"></v-radio> <label class="ml-lg-2 chkboxLabel"> 
                                                <v-row class="mt-n7 ml-6"> <div> 4. End contract and refund </div> 
                                                </v-row> </label>

                                             <v-radio value="5"></v-radio> <label class="ml-lg-2 chkboxLabel"> 
                                                <v-row class="mt-n7 ml-6"> <div> 5. No action </div> 
                                                </v-row> </label>

                                             <v-radio value="other"></v-radio> <label class="ml-lg-2 chkboxLabel"> 
                                                <v-row class="mt-n7 ml-6"> <div> 6. Other: </div>  <v-text-field :rules="actTaken=='other' ? inputRules : ''" v-model="othersAct"  :readonly="actTaken=='other' ? false : true" v-bind="attrs" v-on="on" class="input-size-other mt-n7 ml-2 styled-input"></v-text-field>
                                                </v-row> </label>
                                                
                                         </v-radio-group>

                                    </v-flex>

                            </v-layout>

                        </div>  

                </v-flex>
                

                 <v-flex lg12 class="mt-lg-5 pb-5">
                                        
                                        <v-layout justify-end>
                                            <v-btn color="rgb(0, 99, 158)" class="white--text" @click="Savecomplaints()"> SUBMIT </v-btn>
                                        </v-layout>

                </v-flex>  

        </v-layout>

     </v-form>

    <!-- dialogbox -->


        <v-dialog
                            transition="dialog-bottom-transition"
                            max-width="100%"
                            v-model="dialogshow"
                            persistent
                          >
                            <v-card style="background-color:#000C17 !important">
                              <v-card-actions class="justify-end">
                                <v-btn
                                  text
                                  @click="(dialogshow = false)"
                                >
                                  <span class="white--text"> Close </span>
                                </v-btn>
                              </v-card-actions>
                              <v-card-text>

                                <div
                                  class="text-h3 white--text"
                                >
                                  Data Successfully Saved!
                                </div>
                              </v-card-text>
                              <v-card-actions class="justify-end">
                                <v-btn
                                  text
                                  @click="(dialogshow = false)"
                                >
                                  <span class="white--text"> Close </span>
                                </v-btn>
                              </v-card-actions>
                            </v-card>
        </v-dialog>





    </v-app>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
    name:'managerReviewForm',
    props:['bus','cdata'],
    data: () => ({
        itemPerPage:0,
        englishName:'',
        date:'',
        time:'',
        menu:'',
        menu2:'',
        studName:"",
        tutorName:'',
        actTaken:'',
        othersAct:"",
        chkData:[],
        othersChk:'',
        complaints:'',
        inputRules: [
                v => v.length >= 1 || "Item is Required"
            ],
        timestamp: new Date(),
        dialogshow:false,

        

    }),
    computed: {
       headers(){ return  [{

          
          text: 'Instructor',
          align: 'center',
          sortable: false,
          value: 'instructor',
          class: "grey lighten-2"
        },
        { text: '3 pts',align: 'center', value: 'three' , class: "grey lighten-2", sortable: false,},
        { text: '5 pts',align: 'center', value: 'five' , class: "grey lighten-2", sortable: false,},
        { text: '7 pts',align: 'center', value: 'seven' , class: "grey lighten-2", sortable: false,},
        { text: '10 pts',align: 'center', value: 'ten' , class: "grey lighten-2", sortable: false,},
        
        ]},

        posts(){
            return{
                 actionTaken:'insertdata',
                 event:"complaintsform",
                 updateId:this.cdata.updateId ? this.cdata.updateId : '',
                 tutorId:this.$route.params.t_id,
                 stud_name:this.studName,
                 class_date:this.date,
                 class_time:this.time,
                 tyCom:[{
                     list:JSON.parse(JSON.stringify(this.chkData)),
                     other:this.othersChk
                 }],
                 actTaken:[{
                     list:this.actTaken,
                     other:this.othersAct
                 }],
                 complaints:this.complaints,
                 timestamp: this.cdata.timestamp ? this.cdata.timestamp :  new Date(this.timestamp.getFullYear()+"-"+(this.timestamp.getMonth() >= 9 ? (this.timestamp.getMonth()+1) : "0"+(this.timestamp.getMonth()+1))+"-"+(this.timestamp.getDate() > 9 ? this.timestamp.getDate() : "0"+this.timestamp.getDate())+" "+(this.timestamp.getHours() > 9 ? this.timestamp.getHours() : "0"+this.timestamp.getHours())+":"+(this.timestamp.getMinutes() > 9 ? this.timestamp.getMinutes() : "0"+this.timestamp.getMinutes())+":"+(this.timestamp.getSeconds() > 9 ? this.timestamp.getSeconds() : "0"+this.timestamp.getSeconds()))

            }
        }
    },
    mounted(){
       
         axios.get('https://phone.megatalking.com/origin/api/monitoring.php?action=getTutors')
        //.then(response=>console.warn(response.data))
        .then(response=>{
        
          let tutorlist = response.data
        

              for(let i = 0 ; i<=tutorlist.length ; i++){
                    


                    if(this.$route.params.t_id.toString().toLowerCase().indexOf(tutorlist[i].tutor_id.toLowerCase()) !== -1){
                        this.tutorName = tutorlist[i].tutor_full_name
                    }

               }
               
              })

       this.bus.$on('getComplaintsData', this.getComplaintsData)  
       this.bus.$on('insertNewItem', this.insertNewItem)

    },
    methods:{
        
        Savecomplaints(){

             if(this.$refs.form.validate()){
                 
                axios.post('http://localhost/megatalking/performance/tutorperf.php',this.posts).then(response=>{

                        if(response.data == 'success' || response.data == 'successUpdate'){
                            return (this.dialogshow = true)
                        
                        }
                        

                }).catch(error=>console.log('this is the error '+error))
                
                this.$emit('updateComplaints',this.posts)


             }

        },

        getComplaintsData(){
           
            this.studName =  this.cdata.stud_name
            this.date = this.cdata.cd
            this.time =  this.cdata.ct
            this.complaints = this.cdata.complaints
            this.actTaken = this.cdata.actTaken[0].list
            this.othersAct = this.cdata.actTaken[0].other
            this.chkData = this.cdata.tyCom[0].list
            this.othersChk = this.cdata.tyCom[0].other

        },

        OtherChange(){
            this.othersChk = this.chkData.includes('other') ? this.othersChk : '';
            this.othersAct = this.actTaken == 'other' ? this.othersAct :'';
        },

        insertNewItem(){

            this.cdata =[]
            this.studName =  ""
            this.date = ""
            this.time =  ""
            this.complaints = ""
            this.actTaken = ""
            this.othersAct = ""
            this.chkData = []
            this.othersChk = ""

        }
      
   }
}
</script>
<style scoped>
#form{
    background-color: rgb(246, 246, 246);
}
.font-11
{
    font-size:11px
}
.font-14{
    font-size:14px
}
.font-9
{
    font-size:9px
}
.input-size{
    max-width: 130px !important;
}
.input-size-other{
    max-width: 300px !important;
}
.styled-input label[for] {
  height: 40px;
  font-size: 9px !important;
}

.barcolor{
    background-color: rgb(229, 229, 229);
    padding: 20px !important;
    font-weight: bold;
    width:100% !important;
}
.textareaBg{
    background-color: white !important;
}
.textarea{
    width:500px !important;
    font-size:10px;
}

.chkboxLabel{
    font-size:14px;
}
</style>